import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { EditorState, Modifier } from 'draft-js';

export default class CustomOption extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    editorState: PropTypes.object,
  };

  state = {
    open: false,
  };

  openPlaceholderDropdown = () => this.setState({ open: !this.state.open });

  addStar = (fieldName) => {
    const { editorState, onChange } = this.props;
    const contentState = Modifier.replaceText(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      `{{${fieldName}}}`,
      editorState.getCurrentInlineStyle(),
    );
    onChange(EditorState.push(editorState, contentState, 'insert-characters'));
  };

  render() {
    const { selectedCollectionFields } = this.props;
    return (
      <div
        onClick={this.openPlaceholderDropdown}
        className="rdw-block-wrapper"
        aria-label="rdw-block-control"
      >
        <div className="rdw-dropdown-wrapper rdw-block-dropdown" aria-label="rdw-dropdown">
          <div className="rdw-dropdown-selectedtext" title="Placeholders">
            <span>Select Field</span>
            <div className={`rdw-dropdown-caretto${this.state.open ? 'close' : 'open'}`}></div>
          </div>
          <ul className={`rdw-dropdown-optionwrapper ${this.state.open ? '' : 'placeholder-ul'}`}>
            {selectedCollectionFields.map((e) => {
              return (
                <li
                  key={e.fieldName}
                  className="rdw-dropdownoption-default placeholder-li"
                  onClick={() => this.addStar(e.fieldName)}
                >
                  {e.fieldTitle}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }
}
